export default "__VITE_ASSET__04c839d6__"